// @ts-ignore Variable replacement from DefinePlugin
export const mhaVersion = function () { return __VERSION__; };